// extracted by mini-css-extract-plugin
export default {"p":"text_p__-kuAK","M":"text_M__JZ-pP","S":"text_S__waJcG","L":"text_L__iXY8q","label":"text_label__D+qZV","span":"text_span__dh2CH"};